export const PRE_MATCH_PLACEMENT_WINDOW_MINUTES = 360;
